module.exports = __webpack_public_path__ + "static/img/c4452524a19945e2ea3563390dfea2e2.7e66044f.svg";